export const breakpoints = {
  sm: '568px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1650px',
};
